import React from "react";
import { Grid, MenuItem, TextField } from "@mui/material";

interface Props {
  masters: {
    academicSessions: { id: string; name: string }[];
    classes: { id: string; name: string }[];
    categories: { id: string; name: string }[];
    houses: { id: string; name: string }[];
    religions: { id: string; name: string }[];
    studentTypes: { id: string; name: string }[];
  };
  sections: { id: string; name: string }[];
  filters: Record<string, any>;
  onChange: (next: Record<string, any>) => void;
  reportType: string;
  onReportTypeChange: (type: string) => void;
}

const ReportFilters: React.FC<Props> = ({ masters, sections, filters, onChange, reportType, onReportTypeChange }) => {
  const f = (name: string, value: any) => onChange({ ...filters, [name]: value });
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <TextField select fullWidth label="Report Type" value={reportType} onChange={(e) => onReportTypeChange(e.target.value)}>
          <MenuItem value="ADMISSION_REGISTER">Admission Register</MenuItem>
          <MenuItem value="CLASS_WISE">Class Wise Students</MenuItem>
          <MenuItem value="CATEGORY">Category Report</MenuItem>
          <MenuItem value="HOUSE_WISE">House Wise Report</MenuItem>
          <MenuItem value="RTE">RTE Students</MenuItem>
          <MenuItem value="BPL">BPL Students</MenuItem>
          <MenuItem value="STATUS">Active/Inactive Students</MenuItem>
          <MenuItem value="RELIGION">Religion Wise Report</MenuItem>
          <MenuItem value="STUDENT_TYPE">Student Type Report</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField select fullWidth label="Session" value={filters.sessionId || ""} onChange={(e) => f("sessionId", e.target.value)}>
          <MenuItem value="">All</MenuItem>
          {masters.academicSessions.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField select fullWidth label="Class" value={filters.classId || ""} onChange={(e) => f("classId", e.target.value)}>
          <MenuItem value="">All</MenuItem>
          {masters.classes.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          select
          fullWidth
          label="Section"
          value={filters.sectionId || ""}
          onChange={(e) => f("sectionId", e.target.value)}
          disabled={!filters.classId}
        >
          <MenuItem value="">All</MenuItem>
          {sections.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {reportType === "CATEGORY" && (
        <Grid item xs={12} md={3}>
          <TextField select fullWidth label="Category" value={filters.categoryId || ""} onChange={(e) => f("categoryId", e.target.value)}>
            <MenuItem value="">All</MenuItem>
            {masters.categories.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      )}
      {reportType === "HOUSE_WISE" && (
        <Grid item xs={12} md={3}>
          <TextField select fullWidth label="House" value={filters.houseId || ""} onChange={(e) => f("houseId", e.target.value)}>
            <MenuItem value="">All</MenuItem>
            {masters.houses.map((h) => (
              <MenuItem key={h.id} value={h.id}>
                {h.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      )}
      {reportType === "RELIGION" && (
        <Grid item xs={12} md={3}>
          <TextField select fullWidth label="Religion" value={filters.religionId || ""} onChange={(e) => f("religionId", e.target.value)}>
            <MenuItem value="">All</MenuItem>
            {masters.religions.map((r) => (
              <MenuItem key={r.id} value={r.id}>
                {r.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      )}
      {reportType === "STUDENT_TYPE" && (
        <Grid item xs={12} md={3}>
          <TextField select fullWidth label="Student Type" value={filters.studentTypeId || ""} onChange={(e) => f("studentTypeId", e.target.value)}>
            <MenuItem value="">All</MenuItem>
            {masters.studentTypes.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {t.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      )}
      {reportType === "STATUS" && (
        <Grid item xs={12} md={3}>
          <TextField select fullWidth label="Status" value={filters.status || ""} onChange={(e) => f("status", e.target.value)}>
            <MenuItem value="">All</MenuItem>
            <MenuItem value="ACTIVE">Active</MenuItem>
            <MenuItem value="INACTIVE">Inactive</MenuItem>
          </TextField>
        </Grid>
      )}
      {(reportType === "ADMISSION_REGISTER" || reportType === "CLASS_WISE") && (
        <>
          <Grid item xs={12} md={3}>
            <TextField
              label="Admission Date From"
              type="date"
              fullWidth
              value={filters.fromDate || ""}
              onChange={(e) => f("fromDate", e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Admission Date To"
              type="date"
              fullWidth
              value={filters.toDate || ""}
              onChange={(e) => f("toDate", e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </>
      )}
      {reportType === "RTE" && (
        <Grid item xs={12} md={3}>
          <TextField select fullWidth label="RTE" value={"true"} disabled>
            <MenuItem value="true">RTE Only</MenuItem>
          </TextField>
        </Grid>
      )}
      {reportType === "BPL" && (
        <Grid item xs={12} md={3}>
          <TextField select fullWidth label="BPL" value={"true"} disabled>
            <MenuItem value="true">BPL Only</MenuItem>
          </TextField>
        </Grid>
      )}
    </Grid>
  );
};

export default ReportFilters;
